import { inject, Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { MetricRequest } from '@core/models/metric.models'
import { environment } from '@env'
import { catchObsError } from '@shared/decorators/catch-obs-error.decorator'
import { MatchMetricDetail, MetricDetail } from '@features/metric-detail/models/metric-detail.models'

@Injectable({ providedIn: 'root' })
export class MetricDetailApi {
  private readonly _http: HttpClient = inject(HttpClient)

  @catchObsError()
  fetchPlayerMetricDetail(payload: MetricRequest): Observable<MetricDetail> {
    const { seasonId, competitionId, teamId, playerId, metricKey, playerPosition, comparePlayerId, compareTeamId } =
      payload
    const params =
      comparePlayerId && compareTeamId
        ? new HttpParams()
            .set('comparePlayerId', comparePlayerId)
            .set('compareTeamId', compareTeamId)
            .set('playerPosition', playerPosition)
        : new HttpParams().set('playerPosition', playerPosition)

    return this._http.get<MetricDetail>(
      environment.api.playerMetricDetailUrlFn(seasonId, competitionId, teamId, playerId, metricKey),
      {
        params
      }
    )
  }

  @catchObsError()
  fetchMatchPlayerMetricDetail(payload: MetricRequest): Observable<MetricDetail> {
    const { matchId, teamId, playerId, metricKey, playerPosition, comparePlayerId, compareTeamId } = payload
    const params =
      comparePlayerId && compareTeamId
        ? new HttpParams()
            .set('comparePlayerId', comparePlayerId)
            .set('compareTeamId', compareTeamId)
            .set('playerPosition', playerPosition)
        : new HttpParams().set('playerPosition', playerPosition)

    return this._http.get<MetricDetail>(
      environment.api.matchPlayerMetricDetailUrlFn(matchId, teamId, playerId, metricKey),
      {
        params
      }
    )
  }

  @catchObsError()
  fetchTeamMetricDetail(payload: MetricRequest): Observable<MetricDetail> {
    const { teamId, seasonId, competitionId, metricKey, compareTeamId } = payload
    const params = compareTeamId ? new HttpParams().set('compareTeamId', compareTeamId) : new HttpParams()
    return this._http.get<MetricDetail>(
      environment.api.teamMetricDetailUrlFn(seasonId, competitionId, teamId, metricKey),
      {
        params
      }
    )
  }

  @catchObsError()
  fetchMatchTeamMetricDetail(payload: MetricRequest): Observable<MatchMetricDetail> {
    const { matchId, metricKey } = payload
    return this._http.get<MatchMetricDetail>(environment.api.matchTeamMetricDetailUrlFn(matchId, metricKey))
  }
}
